'use strict';

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }

function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) { n[e] = r[e]; } return n; }

function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }

function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }

function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }

function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }

function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }

function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }

function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }

function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }

function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }

var _Symbol$for;

function _classPrivateFieldLooseBase(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }

  return receiver;
}

var id = 0;

function _classPrivateFieldLooseKey(name) {
  return "__private_" + id++ + "_" + name;
}

import fetchWithNetworkError from '@uppy/utils/lib/fetchWithNetworkError';
import ErrorWithCause from '@uppy/utils/lib/ErrorWithCause';
import AuthError from './AuthError.js';
var packageJson = {
  "version": "3.1.3"
}; // Remove the trailing slash so we can always safely append /xyz.

function stripSlash(url) {
  return url.replace(/\/$/, '');
}

function handleJSONResponse(_x) {
  return _handleJSONResponse.apply(this, arguments);
} // todo pull out into core instead?


function _handleJSONResponse() {
  _handleJSONResponse = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(res) {
    var jsonPromise, errMsg, errData;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            if (!(res.status === 401)) {
              _context8.next = 2;
              break;
            }

            throw new AuthError();

          case 2:
            jsonPromise = res.json();

            if (!res.ok) {
              _context8.next = 5;
              break;
            }

            return _context8.abrupt("return", jsonPromise);

          case 5:
            errMsg = "Failed request with status: ".concat(res.status, ". ").concat(res.statusText);
            _context8.prev = 6;
            _context8.next = 9;
            return jsonPromise;

          case 9:
            errData = _context8.sent;
            errMsg = errData.message ? "".concat(errMsg, " message: ").concat(errData.message) : errMsg;
            errMsg = errData.requestId ? "".concat(errMsg, " request-Id: ").concat(errData.requestId) : errMsg;
            _context8.next = 16;
            break;

          case 14:
            _context8.prev = 14;
            _context8.t0 = _context8["catch"](6);

          case 16:
            throw new Error(errMsg);

          case 17:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8, null, [[6, 14]]);
  }));
  return _handleJSONResponse.apply(this, arguments);
}

var allowedHeadersCache = new Map();

var _companionHeaders = /*#__PURE__*/_classPrivateFieldLooseKey("companionHeaders");

var _getUrl = /*#__PURE__*/_classPrivateFieldLooseKey("getUrl");

var _request = /*#__PURE__*/_classPrivateFieldLooseKey("request");

_Symbol$for = Symbol.for('uppy test: getCompanionHeaders');

var RequestClient = /*#__PURE__*/function (_Symbol$for2) {
  function RequestClient(uppy, opts) {
    _classCallCheck(this, RequestClient);

    Object.defineProperty(this, _request, {
      value: _request2
    });
    Object.defineProperty(this, _getUrl, {
      value: _getUrl2
    });
    Object.defineProperty(this, _companionHeaders, {
      writable: true,
      value: void 0
    });
    this.uppy = uppy;
    this.opts = opts;
    this.onReceiveResponse = this.onReceiveResponse.bind(this);
    _classPrivateFieldLooseBase(this, _companionHeaders)[_companionHeaders] = opts == null ? void 0 : opts.companionHeaders;
  }

  _createClass(RequestClient, [{
    key: "setCompanionHeaders",
    value: function setCompanionHeaders(headers) {
      _classPrivateFieldLooseBase(this, _companionHeaders)[_companionHeaders] = headers;
    }
  }, {
    key: _Symbol$for2,
    value: function value() {
      return _classPrivateFieldLooseBase(this, _companionHeaders)[_companionHeaders];
    }
  }, {
    key: "hostname",
    get: function get() {
      var _this$uppy$getState = this.uppy.getState(),
          companion = _this$uppy$getState.companion;

      var host = this.opts.companionUrl;
      return stripSlash(companion && companion[host] ? companion[host] : host);
    }
  }, {
    key: "headers",
    value: function () {
      var _headers = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var defaultHeaders;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                defaultHeaders = {
                  Accept: 'application/json',
                  'Content-Type': 'application/json',
                  'Uppy-Versions': "@uppy/companion-client=".concat(RequestClient.VERSION)
                };
                return _context.abrupt("return", _objectSpread(_objectSpread({}, defaultHeaders), _classPrivateFieldLooseBase(this, _companionHeaders)[_companionHeaders]));

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function headers() {
        return _headers.apply(this, arguments);
      }

      return headers;
    }()
  }, {
    key: "onReceiveResponse",
    value: function onReceiveResponse(_ref) {
      var headers = _ref.headers;
      var state = this.uppy.getState();
      var companion = state.companion || {};
      var host = this.opts.companionUrl; // Store the self-identified domain name for the Companion instance we just hit.

      if (headers.has('i-am') && headers.get('i-am') !== companion[host]) {
        this.uppy.setState({
          companion: _objectSpread(_objectSpread({}, companion), {}, _defineProperty({}, host, headers.get('i-am')))
        });
      }
    }
    /*
      Preflight was added to avoid breaking change between older Companion-client versions and
      newer Companion versions and vice-versa. Usually the break will manifest via CORS errors because a
      version of companion-client could be sending certain headers to a version of Companion server that
      does not support those headers. In which case, the default preflight would lead to CORS.
      So to avoid those errors, we do preflight ourselves, to see what headers the Companion server
      we are communicating with allows. And based on that, companion-client knows what headers to
      send and what headers to not send.
       The preflight only happens once throughout the life-cycle of a certain
      Companion-client <-> Companion-server pair (allowedHeadersCache).
      Subsequent requests use the cached result of the preflight.
      However if there is an error retrieving the allowed headers, we will try again next time
    */

  }, {
    key: "preflight",
    value: function () {
      var _preflight = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(path) {
        var _this = this;

        var allowedHeadersCached, fallbackAllowedHeaders, promise;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                allowedHeadersCached = allowedHeadersCache.get(this.hostname);

                if (!(allowedHeadersCached != null)) {
                  _context3.next = 3;
                  break;
                }

                return _context3.abrupt("return", allowedHeadersCached);

              case 3:
                fallbackAllowedHeaders = ['accept', 'content-type', 'uppy-auth-token'];
                promise = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
                  var response, header, allowedHeaders;
                  return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          _context2.prev = 0;
                          _context2.next = 3;
                          return fetch(_classPrivateFieldLooseBase(_this, _getUrl)[_getUrl](path), {
                            method: 'OPTIONS'
                          });

                        case 3:
                          response = _context2.sent;
                          header = response.headers.get('access-control-allow-headers');

                          if (!(header == null || header === '*')) {
                            _context2.next = 8;
                            break;
                          }

                          allowedHeadersCache.set(_this.hostname, fallbackAllowedHeaders);
                          return _context2.abrupt("return", fallbackAllowedHeaders);

                        case 8:
                          _this.uppy.log("[CompanionClient] adding allowed preflight headers to companion cache: ".concat(_this.hostname, " ").concat(header));

                          allowedHeaders = header.split(',').map(function (headerName) {
                            return headerName.trim().toLowerCase();
                          });
                          allowedHeadersCache.set(_this.hostname, allowedHeaders);
                          return _context2.abrupt("return", allowedHeaders);

                        case 14:
                          _context2.prev = 14;
                          _context2.t0 = _context2["catch"](0);

                          _this.uppy.log("[CompanionClient] unable to make preflight request ".concat(_context2.t0), 'warning'); // If the user gets a network error or similar, we should try preflight
                          // again next time, or else we might get incorrect behaviour.


                          allowedHeadersCache.delete(_this.hostname); // re-fetch next time

                          return _context2.abrupt("return", fallbackAllowedHeaders);

                        case 19:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2, null, [[0, 14]]);
                }))();
                allowedHeadersCache.set(this.hostname, promise);
                return _context3.abrupt("return", promise);

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function preflight(_x2) {
        return _preflight.apply(this, arguments);
      }

      return preflight;
    }()
  }, {
    key: "preflightAndHeaders",
    value: function () {
      var _preflightAndHeaders = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(path) {
        var _this2 = this;

        var _yield$Promise$all, _yield$Promise$all2, allowedHeaders, headers;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return Promise.all([this.preflight(path), this.headers()]);

              case 2:
                _yield$Promise$all = _context4.sent;
                _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
                allowedHeaders = _yield$Promise$all2[0];
                headers = _yield$Promise$all2[1];
                return _context4.abrupt("return", Object.fromEntries(Object.entries(headers).filter(function (_ref2) {
                  var _ref5 = _slicedToArray(_ref2, 1),
                      header = _ref5[0];

                  if (!allowedHeaders.includes(header.toLowerCase())) {
                    _this2.uppy.log("[CompanionClient] excluding disallowed header ".concat(header));

                    return false;
                  }

                  return true;
                })));

              case 7:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function preflightAndHeaders(_x3) {
        return _preflightAndHeaders.apply(this, arguments);
      }

      return preflightAndHeaders;
    }()
  }, {
    key: "get",
    value: function () {
      var _get = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(path, options) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (options === void 0) {
                  options = undefined;
                } // TODO: remove boolean support for options that was added for backward compatibility.
                // eslint-disable-next-line no-param-reassign


                if (typeof options === 'boolean') options = {
                  skipPostResponse: options
                };
                return _context5.abrupt("return", _classPrivateFieldLooseBase(this, _request)[_request](_objectSpread(_objectSpread({}, options), {}, {
                  path: path
                })));

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function get(_x4, _x5) {
        return _get.apply(this, arguments);
      }

      return get;
    }()
  }, {
    key: "post",
    value: function () {
      var _post = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(path, data, options) {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (options === void 0) {
                  options = undefined;
                } // TODO: remove boolean support for options that was added for backward compatibility.
                // eslint-disable-next-line no-param-reassign


                if (typeof options === 'boolean') options = {
                  skipPostResponse: options
                };
                return _context6.abrupt("return", _classPrivateFieldLooseBase(this, _request)[_request](_objectSpread(_objectSpread({}, options), {}, {
                  path: path,
                  method: 'POST',
                  data: data
                })));

              case 3:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function post(_x6, _x7, _x8) {
        return _post.apply(this, arguments);
      }

      return post;
    }()
  }, {
    key: "delete",
    value: function () {
      var _delete2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(path, data, options) {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (data === void 0) {
                  data = undefined;
                } // TODO: remove boolean support for options that was added for backward compatibility.
                // eslint-disable-next-line no-param-reassign


                if (typeof options === 'boolean') options = {
                  skipPostResponse: options
                };
                return _context7.abrupt("return", _classPrivateFieldLooseBase(this, _request)[_request](_objectSpread(_objectSpread({}, options), {}, {
                  path: path,
                  method: 'DELETE',
                  data: data
                })));

              case 3:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function _delete(_x9, _x10, _x11) {
        return _delete2.apply(this, arguments);
      }

      return _delete;
    }()
  }]);

  return RequestClient;
}(_Symbol$for);

export { RequestClient as default };

function _getUrl2(url) {
  if (/^(https?:|)\/\//.test(url)) {
    return url;
  }

  return "".concat(this.hostname, "/").concat(url);
}

function _request2(_x12) {
  return _request3.apply(this, arguments);
}

function _request3() {
  _request3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(_ref3) {
    var path, _ref3$method, method, data, skipPostResponse, signal, headers, response;

    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            path = _ref3.path, _ref3$method = _ref3.method, method = _ref3$method === void 0 ? 'GET' : _ref3$method, data = _ref3.data, skipPostResponse = _ref3.skipPostResponse, signal = _ref3.signal;
            _context9.prev = 1;
            _context9.next = 4;
            return this.preflightAndHeaders(path);

          case 4:
            headers = _context9.sent;
            _context9.next = 7;
            return fetchWithNetworkError(_classPrivateFieldLooseBase(this, _getUrl)[_getUrl](path), {
              method: method,
              signal: signal,
              headers: headers,
              credentials: this.opts.companionCookiesRule || 'same-origin',
              body: data ? JSON.stringify(data) : null
            });

          case 7:
            response = _context9.sent;
            if (!skipPostResponse) this.onReceiveResponse(response);
            return _context9.abrupt("return", handleJSONResponse(response));

          case 12:
            _context9.prev = 12;
            _context9.t0 = _context9["catch"](1);

            if (!(_context9.t0 != null && _context9.t0.isAuthError)) {
              _context9.next = 16;
              break;
            }

            throw _context9.t0;

          case 16:
            throw new ErrorWithCause("Could not ".concat(method, " ").concat(_classPrivateFieldLooseBase(this, _getUrl)[_getUrl](path)), {
              cause: _context9.t0
            });

          case 17:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9, this, [[1, 12]]);
  }));
  return _request3.apply(this, arguments);
}

RequestClient.VERSION = packageJson.version;